import { HexColorPicker } from "react-colorful";
import type { Effect } from "../api/types";

export interface LedPickerValue {
  color: string;
  luminance: number;
  effect: Effect;
}

interface LedPickerProps {
  value: LedPickerValue;
  onChange: (value: LedPickerValue) => void;
  disabled?: boolean;
}

export default function LedPicker({ value, onChange, disabled }: LedPickerProps) {
  const fade = disabled ? "opacity-60 pointer-events-none" : "";
  return (
    <div className={`space-y-4 ${fade}`}>
      <div className="flex gap-4">
        <div className="flex-shrink-0">
          <HexColorPicker
            color={value.color}
            onChange={(color) => onChange({ ...value, color: color.toUpperCase() })}
          />
        </div>
        <div className="flex flex-1 flex-col gap-3">
          <label className="block text-xs font-medium uppercase tracking-wide text-slate-400">
            Hex
            <input
              type="text"
              value={value.color}
              onChange={(e) => {
                const v = e.target.value.toUpperCase();
                if (/^#[0-9A-F]{0,6}$/.test(v)) onChange({ ...value, color: v });
              }}
              onBlur={(e) => {
                if (!/^#[0-9A-F]{6}$/.test(e.target.value)) {
                  onChange({ ...value, color: "#FFAA00" });
                }
              }}
              className="mt-1 w-full rounded-md border border-slate-700 bg-slate-800 px-2 py-1 font-mono text-sm"
            />
          </label>

          <div
            className="h-12 rounded-md border border-slate-700"
            style={{
              backgroundColor: value.effect === "off" ? "#000" : value.color,
              opacity: value.effect === "off" ? 0.3 : value.luminance / 100,
            }}
            aria-label="preview"
          />

          <label className="block text-xs font-medium uppercase tracking-wide text-slate-400">
            Luminance {value.luminance}
            <input
              type="range"
              min={0}
              max={100}
              value={value.luminance}
              onChange={(e) => onChange({ ...value, luminance: Number(e.target.value) })}
              className="mt-1 w-full accent-brand"
            />
          </label>

          <div className="flex gap-2 pt-1">
            {(["solid", "off"] as const).map((e) => (
              <button
                key={e}
                type="button"
                onClick={() => onChange({ ...value, effect: e })}
                className={`flex-1 rounded-md border px-3 py-1 text-sm ${
                  value.effect === e
                    ? "border-brand bg-brand/20 text-brand"
                    : "border-slate-700 bg-slate-800 text-slate-300 hover:border-slate-600"
                }`}
              >
                {e}
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
